import { resourceReducer, getResources } from 'redux-resource';
import { reset, httpStatusCodes } from 'redux-resource-plugins';
import metaReducer from './metaReducer';

const attSubs = resourceReducer('attSubs', {
  plugins: [reset, metaReducer, httpStatusCodes],
});

export default attSubs;

export const getAllAttSubs = (state, page = 1) =>
  getResources(state, `page${page}`);
export const getAllUserAttSubs = (state, userId) =>
  getResources(state, `userAttSubs${userId}`);
export const getAttSub = (state, id) => state.resources[id];
export const getAttSubNotFound = (state, id) =>
  state.meta[id] && state.meta[id].readStatusCode === 404;
export const getAttSubNotFoundFromFind = (state) =>
  Boolean(
    state.requests &&
      state.requests.find &&
      state.requests.find.statusCode === 404,
  );
export const getUserAttSubs = (state) => getResources(state, 'userSubs');
export const getAllAttSubsCount = (state, page) =>
  state.requests[`fetchAttByUser${page}`] &&
  state.requests[`fetchAttByUser${page}`].count;
export const getCreatedAttSub = (state) =>
  state.requests.create &&
  state.requests.create.status === 'SUCCEEDED' &&
  state.resources[state.requests.create.ids[0]];
export const getAttDeviceDetails = (state) =>
  state.requests.updateDevice && state.requests.updateDevice.details;
export const getAttActivationResponse = (state, subId) =>
  state.meta[subId] && state.meta[subId].activation;
export const getSearchAttSubs = (state, page = 1) =>
  getResources(state, `searchPage${page}`);
export const getAttSubUpcomingPlan = (state, subId) =>
  state.meta[subId] && state.meta[subId].upcomingPlan;
export const getAttFilteredSubs = (state, requestKey, page) =>
  getResources(state, requestKey);
export const getAttFilteredSubsCount = (state, requestKey) =>
  state.requests[requestKey] && state.requests[requestKey].count;
export const getAllAttInitialsSubs = (state) =>
  getResources(state, `allAttInitialsSubs`);
export const getAllAttInitialsSubsStatus = (state) =>
  state.requests.fetchAllAttInitialsSubs &&
  state.requests.fetchAllAttInitialsSubs.status;
export const getFilteredAttSubs = (state, filter, page) =>
  getResources(state, `${filter}Subs${page}`);
